/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { StyledModal, ModalActions, ButtonGroup, Button } from 'sarsaparilla';
import * as tripPlannerActions from '../actions/tripPlanner';

const propTypes = {
    showTripShareModal: PropTypes.bool,
    trip_id: PropTypes.string,
    dispatch: PropTypes.func,
};

const defaultProps = {
    showTripShareModal: false,
};

export class TripShareModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShareModalOpen: false,
            shareLink: window.location.href,
        };

        this.shareLinkInput = null;
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalOpen = this.onModalOpen.bind(this);
        this.onCopyToClipboard = this.onCopyToClipboard.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.showTripShareModal !== this.props.showTripShareModal) {
            this.setState({ isShareModalOpen: nextProps.showTripShareModal });
        }
    }

    onCopyToClipboard() {
        this.shareLinkInput.select();
        document.execCommand('copy');
    }

    onModalOpen() {
        this.shareLinkInput.focus();
    }

    onModalClose() {
        this.props.dispatch(tripPlannerActions.setShowTripShareModal(false));
        this.setState({ isShareModalOpen: false });
    }

    render() {
        return (
            <div>
                <StyledModal
                    isOpen={this.state.isShareModalOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    role="complementary"
                    ariaHideApp={false}
                    contentLabel="Trip Planner Share"
                    heading="Share Trip"
                >
                    <div className="trip-planner-share-trip-modal-view">
                        <p>
                            You can share this trip with friends and family. Simply copy
                            the url and email it to them. They will have read-only view of
                            your trip and will not be able see any booking information.
                        </p>
                        <div className="trip-planner-do-not-show-again-input">
                            <label htmlFor="shareLink">Share Trip</label>
                            <input
                                id="shareLink"
                                name="shareLink"
                                type="text"
                                value={this.state.shareLink}
                                ref={(input) => {
                                    this.shareLinkInput = input;
                                }}
                                onFocus={(e) => e.target.select()}
                                readOnly
                            />
                        </div>
                    </div>
                    <ModalActions>
                        <ButtonGroup>
                            <Button
                                appearance="tertiary"
                                title="Copy to clipboard"
                                aria-label="Copy to clipboard"
                                onClick={this.onCopyToClipboard}
                            >
                                Copy to Clipboard
                            </Button>
                            <Button
                                title="Close"
                                aria-label="Close"
                                onClick={this.onModalClose}
                            >
                                Close
                            </Button>
                        </ButtonGroup>
                    </ModalActions>
                </StyledModal>
            </div>
        );
    }
}

TripShareModal.propTypes = propTypes;
TripShareModal.defaultProps = defaultProps;

function select(state) {
    return {
        trip_id: state.tripPlanner.trip.trip_id,
        showTripShareModal: state.tripPlanner.showTripShareModal,
    };
}

export default connect(select)(TripShareModal);
